import { useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  useEffect(() => {
    document.title = "404 – Page Not Found | UPSC Journey";
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 px-6 text-center">
      <h1 className="text-6xl font-extrabold text-yellow-500 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-3">
        Page Not Found
      </h2>
      <p className="text-gray-600 dark:text-gray-400 max-w-md mb-6">
        The page you’re looking for doesn’t exist or has been removed.
      </p>

      <Link
        to="/"
        className="px-6 py-3 rounded-lg bg-gradient-to-r from-yellow-400 to-red-400 text-gray-900 font-semibold shadow hover:opacity-95 transition"
      >
        Go back to Home
      </Link>
    </div>
  );
};

export default NotFound;
